export default __webpack_public_path__ + "static/media/noordzee.271dc2d9.png";